import React, { useEffect } from "react";
import { Btn } from "../../../AbstractElements";
import {
  useGetOrgUnitsData,
  useGradeMastersData,
} from "../../Configuration/Grade Master/hooks/useGradeMaster";
import RouteDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useFolderParentData } from "../hooks/useMaterial";
import { handleMedia } from "../../ProductCatalogue/repositories/BrandCampaignRepository";
import { FaTrash } from "react-icons/fa";
import { Spinner } from "reactstrap";
interface FolderModalContentProps {
  handleSubmit: (e: React.FormEvent) => void;
  handleClose: () => void;
  setFormValues: any;
  formValues: any;
  editModalStatus: string;
  rowSelected: any;
  isSubmitting: boolean;
  setIsSubmitting: (val: boolean) => void;
}
const FileModalContent: React.FC<FolderModalContentProps> = ({
  handleSubmit,
  handleClose,
  setFormValues,
  formValues,
  editModalStatus,
  rowSelected,
  isSubmitting,
  setIsSubmitting,
}) => {
  console.log(
    "🚀 ~ FileModalContent.tsx:23 ~ FileModalContent ~ editModalStatus:",
    rowSelected
  );

  const BASE_URL = "https://tspc-development.truesales.in/media?id=";

  const { data: gradeMasterFilterData, isLoading: gradeMasterLoading } =
    useGradeMastersData({ enable: true });

  const { data: folderParentData, isLoading: folderParentLoading } =
    useFolderParentData({ enable: true });

  const { data: orgUnitsData, isLoading: orgUnitLoading } = useGetOrgUnitsData({
    enable: true,
  });

  const formattedGradeMasterData =
    gradeMasterFilterData?.data?.map((item: any) => ({
      id: item?.Gradeid,
      label: item?.GradeName,
    })) || [];

  const formattedOrgUnitData = Object.entries(orgUnitsData?.data || {}).map(
    (item: any) => ({
      id: item[0],
      label: item[1],
    })
  );

  const formattedFolderParentData =
    folderParentData?.data
      ?.map((item: any) => ({
        id: item?.FolderId,
        label: item?.FolderName,
      }))
      .slice(1) || [];

  const handleMultiSelectChange = (
    field: "grade" | "orgunit",
    selectedValues: string[] | number[]
  ) => {
    if (field === "grade") {
      const selectedData = selectedValues.map((id) =>
        formattedGradeMasterData.find(
          (unit: any) => Number(unit.id) === Number(id)
        )
      );

      setFormValues((prevState: any) => ({
        ...prevState,
        grade: selectedData.filter(Boolean), // ✅ only update grade
      }));
    }

    if (field === "orgunit") {
      const selectedOrgunitData = selectedValues.map((id) =>
        formattedOrgUnitData.find((unit: any) => Number(unit.id) === Number(id))
      );

      setFormValues((prevState: any) => ({
        ...prevState,
        orgunit: selectedOrgunitData.filter(Boolean), // ✅ only update orgunit
      }));
    }
  };

  const handleDropdownSelect = (field: string, value: string | number) => {
    setFormValues((prevState: any) => ({
      ...prevState,
      [field]: value, // Directly assign the selected value
    }));
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      try {
        const mediaId = await handleMedia(file);
        setFormValues((prev: any) => ({ ...prev, media: mediaId }));
      } catch (error) {
        console.error("Media upload failed:", error);
      }
    }
  };

  useEffect(() => {
    const formattedGrades =
      rowSelected?.Grades?.map((item: any) => ({
        id: item.id,
        label: item.name,
      })) || [];
    const formattedOrgunit =
      rowSelected?.OrgUnits?.map((item: any) => ({
        id: item.id,
        label: item.name,
      })) || [];

    const gradeIds = formattedGrades.map((grade: any) => grade.id); // remove unmatched

    setFormValues({
      name: rowSelected?.Name,
      folder: rowSelected?.FolderId,
      orgunit: formattedOrgunit || [],
      grade: formattedGrades || [],
      description: rowSelected?.Description,
      url: rowSelected?.Url,
      media: rowSelected?.MediaId,
    });
  }, [rowSelected]);

  return (
    <>
      {editModalStatus === "Edit" && !rowSelected ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
          {/* <span className="ms-3">Loading SGPI Brands...</span> */}
        </div>
      ) : (
        <div>
          <div className="row mb-3">
            <div className="col-md-12">
              <label style={{ fontWeight: "500" }}>Name<span style={{color:'red'}}>*</span></label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter name"
                style={{
                  border: "2px solid #EDEDED",
                  borderRadius: "8px",
                  padding: "13px",
                  fontSize: "14px",
                  width: "100%",
                }}
                onChange={(e) =>
                  setFormValues((prev: any) => ({
                    ...prev,
                    name: e.target.value,
                  }))
                }
                value={formValues?.name}
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-12">
              <RouteDropdown
              asterisk
                options={
                  formattedFolderParentData || []
                  // [
                  //   { id: "folder1", label: "folder1" },
                  //   { id: "folder2", label: "folder2" },
                  // ]
                }
                onChange={(value: any) => {
                  handleDropdownSelect("folder", value);
                }}
                DropdownHeading="Folder"
                value={formValues?.folder}
                placeholder={"Select Folder ..."}
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-6">
              <label style={{ fontWeight: "500" }}>Description</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter description"
                style={{
                  border: "2px solid #EDEDED",
                  borderRadius: "8px",
                  padding: "13px",
                  fontSize: "14px",
                  width: "100%",
                }}
                onChange={(e) =>
                  setFormValues((prev: any) => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
                value={formValues?.description}
              />
            </div>
            <div className="col-md-6">
              <label style={{ fontWeight: "500" }}>Url</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter url"
                style={{
                  border: "2px solid #EDEDED",
                  borderRadius: "8px",
                  padding: "13px",
                  fontSize: "14px",
                  width: "100%",
                }}
                onChange={(e) =>
                  setFormValues((prev: any) => ({
                    ...prev,
                    url: e.target.value,
                  }))
                }
                value={formValues?.url}
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-12">
              <RouteDropdown
                options={formattedGradeMasterData || []}
                isMulti={true}
                asterisk={true}
                value={
                  Array.isArray(formValues?.grade)
                    ? formValues.grade.map((g: any) => g.id.toString())
                    : []
                }
                onChange={(value: any) => {
                  handleMultiSelectChange("grade", value);
                }}
                DropdownHeading="Grade"
                placeholder="Select Grade"
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-12">
              <RouteDropdown
                options={formattedOrgUnitData || []}
                isMulti={true}
                asterisk={true}
                value={
                  Array.isArray(formValues?.orgunit)
                    ? formValues.orgunit.map((g: any) => g.id.toString())
                    : []
                }
                onChange={(value: any) => {
                  handleMultiSelectChange("orgunit", value);
                }}
                DropdownHeading="Org Unit"
                placeholder="Select Org Unit"
              />
            </div>
          </div>

          {/* File Upload */}
          {/* Hidden file input */}
          <input
            type="file"
            id="mediaUpload"
            accept="image/*"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />

          {/* Upload Button or Preview */}
          {formValues.media ? (
            <div
              style={{
                position: "relative",
                marginTop: "10px",
                width: "fit-content",
              }}
            >
              <img
                src={
                  formValues?.media
                    ? `${BASE_URL}${formValues?.media}`
                    : "https://via.placeholder.com/100?text=No+Image"
                }
                alt="preview"
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                }}
              />
              <span
                onClick={() => {
                  setFormValues((prevState: any) => ({
                    ...prevState,
                    media: "",
                    mediaFile: null,
                  }));

                  // ✅ Clear input value
                  const fileInput = document.getElementById(
                    "mediaUpload"
                  ) as HTMLInputElement;
                  if (fileInput) fileInput.value = "";
                }}
                style={{
                  position: "absolute",
                  top: "-8px",
                  right: "-8px",
                  background: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "50%",
                  padding: "2px 6px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                <FaTrash size={14} color="red" />
              </span>
            </div>
          ) : (
            <Btn
              style={{
                backgroundColor: "#43B9B2",
                color: "white",
                marginTop: "10px",
              }}
              type="button"
              onClick={() => document.getElementById("mediaUpload")?.click()}
            >
              Upload Image <span style={{ color: "red" }}>*</span>
            </Btn>
          )}

          {/* Buttons */}
          <div className="d-flex justify-content-start mt-3 gap-2">
            <Btn
              style={{ backgroundColor: "#43B9B2", color: "white" }}
              type="submit"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {editModalStatus === "Edit" ? "Update" : "Submit"}
            </Btn>
            <Btn
              style={{
                backgroundColor: "#F9FAFC",
                color: "#000",
                border: "1px solid #E0E0E0",
              }}
              type="button"
              onClick={handleClose}
            >
              Cancel
            </Btn>
          </div>
        </div>
      )}
    </>
  );
};

export default FileModalContent;
